import { useState, useEffect } from 'react';
import { useLang } from '../LangContext';
import translations from '../i18n';
const pub = process.env.PUBLIC_URL;

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { lang, setLang } = useLang();
  const t = translations[lang];
  const isSubpage = window.location.pathname !== '/';
  const homeHref = isSubpage ? '/' : '#home';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const showBg = scrolled || isSubpage;

  return (
    <>
      {/* ── NAVBAR BAR ── */}
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        zIndex: 200,
        height: 'var(--nav-height)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 40px',
        background: showBg ? 'rgba(8,8,8,0.97)' : 'transparent',
        backdropFilter: showBg ? 'blur(12px)' : 'none',
        borderBottom: showBg ? '1px solid rgba(229,0,60,0.2)' : 'none',
        transition: 'background 0.5s ease, border-color 0.5s ease',
      }}>
        <a href={homeHref}>
          <img src={`${pub}/RUDE-Logo.svg`} alt="RUDE" style={{ height: '34px', width: 'auto', filter: 'brightness(0) invert(1)' }} />
        </a>

        <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
          {['it', 'en'].map(l => (
            <button key={l} onClick={() => setLang(l)} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontFamily: 'var(--font-title)', fontWeight: 600,
              fontSize: '11px', letterSpacing: '0.15em',
              color: lang === l ? 'var(--red)' : 'rgba(255,255,255,0.4)',
              textTransform: 'uppercase', padding: '4px 6px', transition: 'color 0.2s',
            }}>{l}</button>
          ))}

          <button
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              padding: '10px', display: 'flex', flexDirection: 'column', gap: '6px',
            }}
          >
            {[0,1,2].map(i => (
              <span key={i} style={{
                display: 'block',
                width: open ? (i === 1 ? '0' : '28px') : (i === 1 ? '20px' : '28px'),
                height: '1.5px',
                background: 'var(--white)',
                transition: 'all 0.35s cubic-bezier(0.16,1,0.3,1)',
                transform: open
                  ? (i === 0 ? 'rotate(45deg) translate(5px,5px)'
                    : i === 2 ? 'rotate(-45deg) translate(5px,-5px)'
                    : 'none')
                  : 'none',
                opacity: open && i === 1 ? 0 : 1,
              }} />
            ))}
          </button>
        </div>
      </nav>

      {/* ── OVERLAY MENU — fuori dalla nav, non intrappolato dal backdropFilter ── */}
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 190,
        background: 'rgba(8,8,8,0.98)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 'var(--nav-height)',
        gap: '2px',
        overflowY: 'auto',
        opacity: open ? 1 : 0,
        pointerEvents: open ? 'all' : 'none',
        transition: 'opacity 0.4s ease',
      }}>
        {t.nav.map((item, i) => {
          const href = isSubpage && item.href.startsWith('#')
            ? `/${item.href}`
            : item.href;
          return (
            <a
              key={i}
              href={href}
              onClick={() => setOpen(false)}
              style={{
                fontFamily: 'var(--font-title)', fontWeight: 600,
                fontSize: 'clamp(1.4rem, 3.5vw, 2.8rem)',
                letterSpacing: '0.05em', textTransform: 'uppercase',
                color: 'var(--white)', lineHeight: 1.3,
                transition: 'color 0.2s, transform 0.2s',
                transitionDelay: `${i * 0.04}s`,
                padding: '4px 0',
              }}
              onMouseEnter={e => { e.target.style.color = 'var(--red)'; e.target.style.transform = 'translateX(8px)'; }}
              onMouseLeave={e => { e.target.style.color = 'var(--white)'; e.target.style.transform = 'translateX(0)'; }}
            >
              {item.label}
            </a>
          );
        })}
        <div style={{
          position: 'absolute', bottom: '40px', left: '40px', right: '40px',
          height: '1px',
          background: 'linear-gradient(90deg, var(--red), transparent)',
        }} />
      </div>
    </>
  );
}
